<template>
    <figure class="snip1533">
        <figcaption>
            <blockquote>
            <p>{{$t(testimContent.quote)}}</p>
            </blockquote>
            <h3>{{$t(testimContent.author.name)}}</h3>
        </figcaption>
    </figure>
</template>

<script>
export default {
    props: ['testimContent']
}
</script>

<style lang="scss" scoped>
@import url(https://fonts.googleapis.com/css?family=Roboto:300,400);
@import url(https://maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css);
.snip1533 {
box-shadow: 0 0 5px rgba(0, 0, 0, 0.15);
color: #9e9e9e;
display: inline-block;
font-family: 'Roboto', Arial, sans-serif;
font-size: 16px;
max-width: 500px;
min-width: 100%;
position: relative;
text-align: center;
width: 100%;
background-color: $secondary-color;
border-radius: 5px;
border-top: 5px solid $primary-color;
}

.snip1533 *,
.snip1533 *:before {
-webkit-box-sizing: border-box;
box-sizing: border-box;
-webkit-transition: all 0.1s ease-out;
transition: all 0.1s ease-out;
margin-top: 20px;
}

.snip1533 figcaption {
padding: 4% 8% 8%;
height: 100%;
}

.snip1533 figcaption:before {
-webkit-transform: translateX(-50%);
transform: translateX(-50%);
background-color: #fff;
border-radius: 50%;
box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
color: $primary-color;
content: "\f10e";
font-family: 'FontAwesome';
font-size: 32px;
font-style: normal;
left: 50%;
line-height: 60px;
position: absolute;
top: -30px;
width: 60px;
}

.snip1533 h3 {
color: black;
font-size: 20px;
font-weight: bold;
line-height: 24px;
margin: 10px 0 5px;
}

.snip1533 h4 {
font-weight: 400;
margin: 0;
opacity: 0.5;
}

.snip1533 blockquote {
font-style: italic;
font-weight: 300;
margin: 0 0 20px;
min-height: 160px;
overflow: hidden;
}

@media (max-width: 900px) {
    figure.snip1533 {
        margin: 10% 1%;
    }
    .snip1533 p{
        margin-left: 7%;
        margin-right: 7%;
    }

    .snip1533 {
        height: 600px;
    }

    .snip1533 figcaption {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
}

</style>
